<template>
    <div :class="{'prezzo' : !!this.graphicLayout, 'prezzo-nofoto': !this.graphicLayout}">
        {{this.text}}
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "IncProductPriceLabel",
    props: ['product', 'currency', 'graphicLayout'],
    computed: {
        text: function () {
            if (this.product.f_prodotto_composto && this.product.prodotto_composto_tipo_prezzo === 'VARIABILE') {
                if (this.product_price) {
                    return this.$t('min') + ' ' + this.product_price.toFixedGood(2) + ' ' + this.currency;
                } else {
                    return this.$t('combo');
                }
            }

            return this.product_price.toFixedGood(2) + " " + this.currency;
        },
        product_price: function () {
            if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order_type)) {
                if (this.product.prezzo_kmenu) return this.product.prezzo_kmenu;
            }
            
            return this.product.prezzo;
        },
        ...mapState('order', {
            order_type: state => state.type
        })
    }
}
</script>

<style scoped>

</style>
